"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AllowedUtms = {
  UTM_SOURCE: 'UTM_SOURCE',
  UTM_MEDIUM: 'UTM_MEDIUM',
  UTM_ID: 'UTM_ID'
};
var _default = AllowedUtms;
exports.default = _default;
module.exports = exports.default;